import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Hur lång tid har jag på mig på kunskapsprovet?";
const SHORT_ANSWER = "90 minuter för stadigvarande till allmänheten (60 frågor). Kortare prov har proportionellt kortare tid.";

export const Route = createFileRoute("/fraga/hur-lang-tid-tar-provet")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Hur lång tid har jag på mig på kunskapsprovet" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Tiden brukar räcka med god marginal om du är förberedd. Funktionshindrade kan ansöka om förlängd tid hos kommunen."}
      source={{ label: "Folkhälsomyndigheten – Kunskapsprov", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/kunskapsprov/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsprov-alkohollagen", label: "Kunskapsprovet – allt om upplägget" }}
      related={[{"to": "/fraga/far-jag-anvanda-lagboken", "label": "Får jag använda lagboken på kunskapsprovet?"}, {"to": "/fraga/kostar-kunskapsprovet-extra", "label": "Kostar kunskapsprovet extra utöver ansökan?"}, {"to": "/fraga/hur-manga-ratt-kravs", "label": "Hur många rätt krävs på kunskapsprovet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Hur lång tid har jag på mig på kunskapsprovet?" },
      { name: "description", content: "90 minuter för stadigvarande till allmänheten (60 frågor). Kortare prov har proportionellt kortare tid." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/hur-lang-tid-tar-provet" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/hur-lang-tid-tar-provet" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/hur-lang-tid-tar-provet",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Hur lång tid har jag på mig på kunskapsprovet", url: "https://alkoholprovet.se/fraga/hur-lang-tid-tar-provet" },
      ]),
    ],
  }),
});
